// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__tkNS0","main-content":"DefaultLayout_main-content__8miox","header":"DefaultLayout_header__B22+R","footer":"DefaultLayout_footer__8xgXb"};